/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Response model for chunk upload
 */
export interface ChunkUploadResponse { 
    success: boolean;
    chunk_index: number;
    video_id: string;
}

